export default "__VITE_ASSET__DU58ZrWR__"